// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"AccountPrivacyPage_layoutWrapperMain__5QxtW"};